export class MediaMediaHashTagCommandModel {
    public mediaMediaHashTagId: string;
    public mediaHashtagId: string;
    public displaySequence: Number;
}
